import React from 'react';
import { Row, Col, FormGroup, Input } from 'reactstrap';
import TextInputMask from 'react-masked-text';

// { label: data.viResolution && 'Video', index: 0 },
// { label: data.auResolution && 'Áudio', index: 1 },
// { label: data.fiResolution && 'PDF', index: 2 },
// viStart viEnd auStart auEnd

function hmsToSecondsOnly(str) {
    try {
        var p = str.split(':'),
        s = 0, m = 1;

        while (p.length > 0) {
            s += m * parseInt(p.pop(), 10);
            m *= 60;
        }

        return s;
    } catch(e){
        return 0
    }
    
}

export const QuestionResolution = ({onChange, item}) => {
    return (
        <>
        <div className="alert-text">
                <span className="alert-information-text">Adicionar resolução da questão:</span>
            </div>
            <Row>
                <Col sm="12">
                    <FormGroup>
                    <span className="title-box input-subtitle">Insira imagem de apoio</span>
                        <Input
                            placeholder="Link da imagem de apoio"
                            type="text"
                            className="input-title"
                            value={item.piReference}
                            onChange={(event) => onChange("piReference", event.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col sm="6">
                    <FormGroup>
                        <span className="title-box input-subtitle">Video</span>
                        <Input
                            placeholder="Insira o link do vídeo"
                            type="text"
                            className="input-title"
                            value={item.viResolution}
                            onChange={(event) => onChange("viResolution", event.target.value)}
                        />
                    </FormGroup>
                </Col>
                <Col sm="3">
                    <FormGroup>
                        <span className="title-box input-subtitle">Ínicio</span>
                        <TextInputMask
                            kind={'datetime'}
                            options={{
                                format: 'HH:mm:ss'
                            }}
                            placeholder="HH:mm:ss"
                            type="text"
                            className="input-title form-control"
                            value={item.viStartTime}
                            onChangeText={(value) => {
                                onChange("viStartTime", value)
                                onChange("viStart", hmsToSecondsOnly(value))
                            }}
                        />
                    </FormGroup>
                </Col>
                <Col sm="3">
                    <FormGroup>
                        <span className="title-box input-subtitle">Fim</span>
                        <TextInputMask
                            kind={'datetime'}
                            options={{
                                format: 'HH:mm:ss'
                            }}
                            placeholder="HH:mm:ss"
                            type="text"
                            className="input-title form-control"
                            value={item.viEndTime}
                            onChangeText={(value) => {
                                onChange("viEndTime", value)
                                onChange("viEnd", hmsToSecondsOnly(value))
                            }}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col sm="6">
                    <FormGroup>
                        <span className="title-box input-subtitle">Áudio</span>
                        <Input
                            placeholder="Insira o link do áudio"
                            type="text"
                            className="input-title"
                            value={item.auResolution}
                            onChange={(event) => onChange("auResolution", event.target.value)}
                        />
                    </FormGroup>
                </Col>
                <Col sm="3">
                    <FormGroup>
                        <span className="title-box input-subtitle">Ínicio</span>
                        <TextInputMask
                            kind={'datetime'}
                            options={{
                                format: 'HH:mm:ss'
                            }}
                            placeholder="HH:mm:ss"
                            type="text"
                            className="input-title form-control"
                            value={item.auStartTime}
                            onChangeText={(value) => {
                                onChange("auStartTime", value)
                                onChange("auStart", hmsToSecondsOnly(value))
                            }}
                        />
                    </FormGroup>
                </Col>
                <Col sm="3">
                    <FormGroup>
                        <span className="title-box input-subtitle">Fim</span>
                        <TextInputMask
                            kind={'datetime'}
                            options={{
                                format: 'HH:mm:ss'
                            }}
                            placeholder="HH:mm:ss"
                            type="text"
                            className="input-title form-control"
                            value={item.auEndTime}
                            onChangeText={(value) => {
                                onChange("auEndTime", value)
                                onChange("auEnd", hmsToSecondsOnly(value))
                            }}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col sm="12">
                    <FormGroup>
                        <span className="title-box input-subtitle">Pdf</span>
                        <Input
                            placeholder="Insira o link do arquivo"
                            type="text"
                            className="input-title"
                            value={item.fiResolution}
                            onChange={(event) => onChange("fiResolution", event.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </>
    )
}